module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_5010.65d036b4.png";